<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  data() {
    return {
      steps: [
        {
          title: this.$t("register.steps.0")
        },
        {
          title: this.$t("register.steps.1")
        },
        {
          title: this.$t("register.steps.2")
        }
      ]
    };
  },
  computed: {
    activeStep() {
      return this.$route.params.step - 1 || 0;
    }
  }
};
</script>
<template>
  <div class="register-steps">
    <router-link
      :to="{
        name: 'RegisterPage1',
        params: { lang: $i18n.locale },
        query: { ...$route.query }
      }"
    >
      <Icon icon="ix:user-profile-filled" class="icon" />
      {{ $t("register.steps.0") }}
    </router-link>
    <router-link
      :to="{
        name: 'RegisterPage2',
        params: { lang: $i18n.locale },
        query: { ...$route.query }
      }"
    >
      <Icon icon="material-symbols:domain-rounded" class="icon" />
      {{ $t("register.steps.1") }}
    </router-link>
    <router-link
      :to="{
        name: 'RegisterPage3',
        params: { lang: $i18n.locale },
        query: { ...$route.query }
      }"
    >
      <Icon icon="material-symbols:interests" class="icon" />

      {{ $t("register.steps.2") }}
    </router-link>
  </div>
</template>
<style scoped lang="scss">
.register-steps {
  text-align: left;
  display: flex;

  a {
    text-decoration: none;
    color: $gray-blue-1300;
    border-bottom: solid 1px $gray-blue-1300;
    padding: 2px 5px;
    display: flex;
    align-items: center;
    gap: 3px;
    .icon {
      transform: translateY(2px);
      font-size: 1.3rem;
    }
    &.router-link-active {
      color: $light-blue-600;
      border-color: $light-blue-600;
      border-width: 2px;
    }
  }
}
</style>
